import { api } from "@/api"

export type Product = {
  id: string
  name: string
  parentCategoryId: string | null
  measure: string | null
  description: string
  price: number
  vatRate: number | null
  color: string
  tagIds: string[]
  hasOptions: boolean
  isActive: boolean
  hasVariablePrice: boolean
  categoryPath: string
}

export const retrieveProduct = async (
  productId: string
): Promise<Product> => {
  const response = await api.get<Product>(
    `/products/products/${productId}`
  )
  return response.body
}
